

import { useMemo } from "react"
import Highcharts from "highcharts"

const useGetBarChartDataWithDropdownFilter = ({ data, selectedMetric, selectedMetrixLabel }) => {

    const barChartData = useMemo(() => {
        if (!selectedMetric || !data) return {};

        const chartOptions = {
            exporting: { enabled: false },
            chart: { type: "bar", margin: [50, 0, 60, 170] },
            title: { text: "", align: "left" },
            xAxis: {
                categories: [],
                title: {
                    text: "Property",
                    align: "middle",
                    offset: 160,
                    rotation: -90,
                    y: 0,
                    style: { fontWeight: "600" }
                }
            },
            yAxis: {
                min: 0,
                title: {
                    text: "Online Review Score",
                    align: "middle",
                    rotation: 0,
                    offset: 45,
                    style: { fontWeight: "bold" }
                }
            },
            legend: { reversed: true },
            plotOptions: {
                series: {
                    stacking: "normal",
                    dataLabels: {
                        enabled: true,
                        align: "left",
                        x: 5,
                        inside: false,
                        style: {
                            color: "black",
                            fontWeight: "bold",
                            fontSize: "12px",
                            textOutline: "1px contrast"
                        }
                    },
                    minPointLength: 10,
                    pointPadding: 0.1,
                    groupPadding: 0.1,
                    showInLegend: false
                }
            },

            series: [],
            credits: { enabled: false }
        };

        const extraConfig = {
            series: [
                {
                    data: data.map(e => e[selectedMetric]),
                    color: "#5E68CB"
                }
            ],
            xAxis: {
                categories: data.map(e => e.Property)
            },
            yAxis: { title: { text: selectedMetrixLabel } },
            plotOptions: {
                series: {
                    dataLabels: {
                        enabled: true,
                        formatter: function () {
                            return this.y != null ? this.y.toFixed(2) : '0.00';
                        }
                    }
                }
            },
            tooltip: {
                useHTML: true,
                outside: true,
                backgroundColor: 'transparent',
                borderWidth: 0,
                shadow: false,
                padding: 0,
                positioner: function (labelWidth, labelHeight, point) {
                    const chart = this.chart;
                    return {
                        x: chart.plotLeft + chart.plotWidth / 2 - labelWidth / 2,
                        y: point.plotY + chart.plotTop - labelHeight - 12
                    };
                },
                formatter: function () {
                    const value = Highcharts.numberFormat(this.y, 2);
                    return `
                       <div style="
                         background: #1e222c;
                         color: #fff;
                         padding: 12px 18px;
                         border-radius: 14px;
                         font-size: 14px;
                         box-shadow: 0 4px 14px rgba(0,0,0,0.25);
                         display: flex;
                         flex-direction: column;
                         gap: 6px;
                         pointer-events: none;
                       ">
                         <div style="font-size: 14px; font-weight: 600;">${this.key}</div>
                         <div style="display: flex; align-items: center; justify-content: space-between;">
                           <div style="display: flex; align-items: center; gap: 6px;">
                             <div style="
                               width: 10px; height: 10px;
                               background: ${this.color};
                             "></div>
                             <div>${selectedMetrixLabel} &nbsp;&nbsp;&nbsp;&nbsp;</div>
                           </div>
                           <span style="font-weight: 600;">${value} </span>
                         </div>
                       </div>
                       <div style="
                         width: 0; height: 0; margin: 0 auto;
                         border-left: 10px solid transparent;
                         border-right: 10px solid transparent;
                         border-top: 12px solid #1e222c;
                       "></div>
                     `;
                }
            },

        };
        return Highcharts.merge(chartOptions, extraConfig);
    }, [data, selectedMetric]);

    return { barChartData };
};

export default useGetBarChartDataWithDropdownFilter;
